import {BaseModel} from './base.model';
import {ResponseError} from './response-error.model';

export class ResponseBase<M extends BaseModel> {
    public success = false;
    public count = 0;
    public results: M[] = [];
    public errors: ResponseError[] = [];
}
